import { NavigationTabs, type NavigationTabItem } from '@exam-center/components';
import { APP_PERMISSIONS } from '@exam-center/permission';
import { usePermission } from '@shared/permissions';
import { useMemo } from 'react';

const TAB_ITEMS: NavigationTabItem[] = [
  {
    value: 'Exam Distribution By Year',
    label: 'รอบสอบทั้งหมด',
    path: '/admin/exam-distribution/year',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.EXAM_ASSIGNING.VIEW],
  },
  {
    value: 'Exam Distribution Available QSets',
    label: 'ชุดข้อสอบที่พร้อมใช้งาน',
    path: '/admin/exam-distribution/available-qsets',
    requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.AVAILABLE_QSETS.VIEW],
  },
];
export default function ExamDistributionNavigationTabs() {
  const { permissions } = usePermission();

  const tabList = useMemo(
    () =>
      TAB_ITEMS.filter((tab) => {
        return tab.requiredPermission?.every((permission) => {
          return permissions.includes(permission);
        });
      }),
    [permissions],
  );

  return <NavigationTabs items={tabList} />;
}
